import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const PaymentOptionListPage = () =>
  import('@modules/payment-option/components/payment-option-list-page.vue');
const PaymentOptionFormPage = () =>
  import('@modules/payment-option/components/payment-option-form-page.vue');
const PaymentOptionViewPage = () =>
  import('@modules/payment-option/components/payment-option-view-page.vue');
const PaymentOptionImporterPage = () =>
  import('@modules/payment-option/components/payment-option-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'payment-option',
        path: '/payment-option',
        component: PaymentOptionListPage,
        meta: {
          auth: true,
          permission: Permissions.values.paymentOptionView,
        },
      },
      {
        name: 'paymentOptionNew',
        path: '/payment-option/new',
        component: PaymentOptionFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.paymentOptionCreate,
        },
      },
      {
        name: 'paymentOptionImporter',
        path: '/payment-option/import',
        component: PaymentOptionImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.paymentOptionImport,
        },
      },
      {
        name: 'paymentOptionEdit',
        path: '/payment-option/:id/edit',
        component: PaymentOptionFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.paymentOptionEdit,
        },
        props: true,
      },
      {
        name: 'paymentOptionView',
        path: '/payment-option/:id',
        component: PaymentOptionViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.paymentOptionView,
        },
        props: true,
      },
    ],
  },
];
